/**
 * WordPress CRO sections: reveal .cro-reveal elements on scroll (honours --delay).
 */
document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.cro-reveal');
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            var delay = parseInt(el.style.getPropertyValue('--delay'), 10) || 0;
            setTimeout(function () { el.classList.add('cro-reveal--visible'); }, delay);
            io.unobserve(el);
        });
    }, { threshold: 0.12 });

    els.forEach(function (el) {
        el.classList.add('cro-reveal--observed');
        io.observe(el);
    });
});
